import { render } from "./AssistantMode.vue?vue&type=template&id=421e0ec0&scoped=true"
import script from "./AssistantMode.vue?vue&type=script&lang=js"
export * from "./AssistantMode.vue?vue&type=script&lang=js"

import "./AssistantMode.vue?vue&type=style&index=0&id=421e0ec0&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-421e0ec0"]])

export default __exports__